// Loader.js
import React from 'react';
import '../Maintenance-styles/Loader.css'; // Estilos específicos del loader

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
